'use strict';

module.exports = place;

/* Get the position of `node` in `parent`. */
function place(parent, child) {
  return parent && parent.children && parent.children.indexOf(child);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-html/lib/omission/util/place.js
// module id = 1157
// module chunks = 0